import Logger from './logger';

const launchQueuedActions = () => {
    if (window.WC.events) {
        Logger.log('events object present');
        for (let i = 0; i < window.WC.events.length; i++) {
            if (window.WC.events[i].event === 'open') {
                window.WC.Closer.open(
                    window.WC.events[i].payload.args,
                    window.WC.events[i].payload.callbacks
                );
                window.WC.events.splice(i, 1);
            }
        }
    } else {
        Logger.log('events object absent');
    }
    document.dispatchEvent(new CustomEvent('CloserLoaded'));
};

export { launchQueuedActions };
